import React, { useState, useEffect } from 'react';
import BlogList from '../components/blog/BlogList';
import BlogSidebar from '../components/blog/BlogSidebar';
import { getPostsForSite, Post, getAllSites } from '../lib/directus';

const SITE_DOMAIN = import.meta.env.VITE_SITE_DOMAIN || 'o4ki.online';

const BlogPage: React.FC = () => {
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState<number | null>(null);
  const [selectedTag, setSelectedTag] = useState<string | null>(null);
  const [selectedArchive, setSelectedArchive] = useState<{ year: number; month: number } | null>(null);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true);
        console.log('Начинаем загрузку постов для домена:', SITE_DOMAIN);
        console.log('Переменные окружения:', {
          VITE_SITE_DOMAIN: import.meta.env.VITE_SITE_DOMAIN,
          VITE_DIRECTUS_API_URL: import.meta.env.VITE_DIRECTUS_API_URL,
          VITE_SITE_ACCESS_KEY: import.meta.env.VITE_SITE_ACCESS_KEY ? '***' : 'не задан'
        });
        
        // Сначала получим все сайты для отладки
        const allSites = await getAllSites();
        console.log('Все сайты в Directus:', allSites);
        
        const allPosts = await getPostsForSite(SITE_DOMAIN);
        console.log('Результат getPostsForSite:', allPosts);
        
        if (Array.isArray(allPosts)) {
          setPosts(allPosts);
          console.log(`Установлено ${allPosts.length} постов`);
        } else {
          console.warn('Полученные данные не являются массивом:', allPosts);
          setPosts([]);
        }
        setError(null);
      } catch (err) {
        console.error('Ошибка загрузки постов:', err);
        setError('Не удалось загрузить посты блога');
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  const filteredPosts = posts.filter((post) => {
    if (searchQuery && !post.title.toLowerCase().includes(searchQuery.toLowerCase()) &&
        !post.excerpt?.toLowerCase().includes(searchQuery.toLowerCase())) {
      return false;
    }
    if (selectedCategory) {
      const hasCategory = post.categories?.some(c => c.categories_id.id === selectedCategory);
      if (!hasCategory) return false;
    }
    if (selectedTag) {
      const hasTag = post.tags?.includes(selectedTag);
      if (!hasTag) return false;
    }
    if (selectedArchive) {
      const postDate = new Date(post.publish_date);
      if (postDate.getFullYear() !== selectedArchive.year ||
          postDate.getMonth() + 1 !== selectedArchive.month) {
        return false;
      }
    }
    return true;
  });

  const handleSearch = (query: string) => setSearchQuery(query);
  const handleCategorySelect = (categoryId: number) =>
    setSelectedCategory(categoryId === selectedCategory ? null : categoryId);
  const handleTagSelect = (tag: string) =>
    setSelectedTag(tag === selectedTag ? null : tag);
  const handleArchiveSelect = (year: number, month: number) => {
    if (selectedArchive?.year === year && selectedArchive.month === month) {
      setSelectedArchive(null);
    } else {
      setSelectedArchive({ year, month });
    }
  };

  const clearFilters = () => {
    setSearchQuery('');
    setSelectedCategory(null);
    setSelectedTag(null);
    setSelectedArchive(null);
  };

  const activeFiltersCount = [searchQuery, selectedCategory, selectedTag, selectedArchive].filter(Boolean).length;

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="mb-10 text-center">
        <h1 className="text-4xl font-bold text-burgundy mb-4">Новости чемпионата</h1>
        <p className="text-gray-600 text-lg max-w-3xl mx-auto">
          Следите за последними событиями, анонсами и материалами проекта ОЧКИ
        </p>
      </div>
      <div className="flex flex-col lg:flex-row gap-12">
        <div className="lg:w-3/4">
          <div className="mb-8 flex flex-wrap items-center justify-between">
            <h2 className="text-2xl font-bold text-burgundy">
              {loading ? 'Загрузка...' : `Все статьи (${filteredPosts.length})`}
            </h2>
            {activeFiltersCount > 0 && (
              <button
                onClick={clearFilters}
                className="text-sm text-gray-600 hover:text-burgundy underline"
              >
                Сбросить фильтры ({activeFiltersCount})
              </button>
            )}
          </div>
          <BlogList posts={filteredPosts} loading={loading} error={error} />
        </div>
        <div className="lg:w-1/4">
          <BlogSidebar
            domain={SITE_DOMAIN}
            onSearch={handleSearch}
            onCategorySelect={handleCategorySelect}
            onTagSelect={handleTagSelect}
            onArchiveSelect={handleArchiveSelect}
          />
        </div>
      </div>
    </div>
  );
};

export default BlogPage;